import { createApp } from 'vue';
import LogoMarquee from './vue-components/LogoMarquee.vue'

const appElements = document.querySelectorAll('.logo-marquee-app');

appElements.forEach((el) => {
    const logos = el.dataset.logos;
    const fadeDelay = el.dataset.fadeDelay; // Assuming you want to pass this as a prop as well

    const app = createApp({
        components: {
            LogoMarquee
        },
        data() {
            return {
                logos,
                fadeDelay // Make sure to define this in your Vue component's props
            };
        }
    });

    // Mount the Vue app to the current element in the loop
    app.mount(el);
});